import { Navigate } from 'react-router-dom'
import useAuthStore from '../../../store/authStore'
import { isPartnerUser, isPmUser } from '../../../services/users'

/**
 * Mostra i children solo se l'utente ha uno dei ruoli richiesti.
 * `allow` accetta i nostri ruoli logici: 'partner' | 'pm' | 'staff'.
 *
 * Convenzione (Fase 0, in attesa di PartnerProfile in Fase 2):
 *   - 'partner' = isPartnerUser (ruolo admin, NON is_staff: un superuser
 *     tecnico break-glass non eredita la visibilità direzionale sui compensi soci)
 *   - 'pm'      = isPmUser (ruolo manager)
 */
export default function RoleGuard({ allow = [], redirectTo = '/', children }) {
  const { user } = useAuthStore()
  const roles = userRoles(user)
  const ok = allow.some((r) => roles.has(r))
  if (!ok) return <Navigate to={redirectTo} replace />
  return children
}

export function userRoles(user) {
  const set = new Set()
  if (!user) return set
  if (isPartnerUser(user)) set.add('partner')
  if (isPmUser(user)) set.add('pm')
  if (user.role === 'staff') set.add('staff')
  return set
}

export function userHasRole(user, role) {
  return userRoles(user).has(role)
}
